import { HttpMethod } from "../types/index.js";
export default function (provider) {
  return {
    acknowledgements(body) {
      return provider.send("/acknowledgements", HttpMethod.POST, body);
    },

    getAttachment(id) {
      return provider.send(`/attachments/${id}`, HttpMethod.GET);
    },

    sendMessages(body) {
      return provider.send("/messages", HttpMethod.POST, body);
    },

    uploadAttachment(body) {
      return provider.send("/attachments", HttpMethod.POST, body);
    }

  };
}